import { ISkillGroupResponse } from "../../_shared/types";

namespace SkillGroupGETDetailResponse {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const _ = 0;
  export namespace Response {
    export type Payload = ISkillGroupResponse;
  }
}

export default SkillGroupGETDetailResponse;
